import { createContext, useContext } from 'react';

export interface ToastRequest {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

export interface ToastApi {
  show: (toast: ToastRequest) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const api = useContext(ToastContext);
  if (!api) throw new Error('useToast вызван вне ToastProvider');
  return api;
}
